import React, { useCallback, useState } from "react";
import { css } from "@emotion/react";
import jwt_decode from "jwt-decode";
import { useAppState } from "core/contexts/AppContext";
import {
    needEmailVerification,
    needSocialConfirmation,
    sendEmailVerification,
    sendManage,
    sendSelectPlan,
    sendSocialConfirmation,
    SocialLoginType,
    socialLogin,
    sendHomeUserMain,
} from "core/includes/auth";
import Loading from "core/Components/Utils/Loading";
import LoginError from "pages/includes/LoginError";
import SignIn from "./SignIn";

type UrlsType = {
    socialConfirmationURL: string,
    emailVerificationURL: string,
    successURL: string,
};

type Props = {
    urls: UrlsType,
    onLoginDialogClose?: () => void,
    isLoginDialog?: boolean,
    showSignUp?: boolean,
};

const Auth: React.FC<Props> = ({
    isLoginDialog,
    onLoginDialogClose,
}) => {
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [appState, setAppState] = useAppState();

    const redirectAfterAuth = useCallback((userInfo: any) => {
        setAppState({ authorized: true });

        if (isLoginDialog) {
            if (needEmailVerification(userInfo)) {
                sendEmailVerification();
            }
            return;
        }
        if (needSocialConfirmation(appState?.user)) {
            sendSocialConfirmation();
        } else if (needEmailVerification(userInfo)) {
            if (userInfo?.Subscription?.IsValid) {
                sendManage();
            } else {
                sendEmailVerification();
            }
        } else if (userInfo?.Subscription) {
            sendSelectPlan();
        } else {
            sendHomeUserMain();
        }
    }, [isLoginDialog, setAppState, appState?.user]);

    const socialSignUp = useCallback((socialProfile: any, socialLoginType: SocialLoginType) => {
        setLoading(true);
        setErrorMessage("");

        let email: any;
        const credential = socialProfile["credential"];
        if (socialLoginType === "google") {
            const decodedData: any = jwt_decode(credential);
            email = decodedData.email;
        } else {
            email = socialProfile.email;
        }

        socialLogin(
            email,
            credential,
            socialLoginType
        ).then(() => {
            appState.getUser().then(redirectAfterAuth);
        }).catch((e: LoginError) => {
            setErrorMessage(e.message);
            setLoading(false);
        });
    }, [appState, redirectAfterAuth]);

    const authContainerStyle = () => css`
        padding: 0;
        margin: 0;
        position: relative;
        width: 100%;
    `;

    return (
        <div css={authContainerStyle}>
            {loading && (<Loading onTop overlay overlayColour={"white"} />)}
            <SignIn
                socialSignUp={socialSignUp}
                errorMessage={errorMessage}
                redirectAfterSignIn={redirectAfterAuth}
                isLoginDialog={isLoginDialog}
                onLoginDialogClose={onLoginDialogClose}
            />
        </div>
    );
};

export default Auth;